module.exports = __webpack_public_path__ + "activities_fg_1.2d18d910c61051cce5b3dbd23c62ee31.png";